import { asBadgeConfig, badgeConfigTiers, type BadgeConfig } from "@fitness-app/data-models/entities/Badge";

/** "progi: 10/50/100" for a config with tiers, empty string otherwise. */
export const formatTiers = (config: unknown): string => {
  const tiers = badgeConfigTiers(asBadgeConfig(config));

  return tiers.length > 0 ? `progi: ${tiers.join("/")}` : "";
};

/** Parses "10, 50, 100" into a sorted, deduplicated list of positive numbers. */
export const parseTiersInput = (raw?: string | null): number[] => {
  const parsed = (raw ?? "")
    .split(/[,;\s]+/)
    .map((part) => Number(part.trim()))
    .filter((value) => Number.isFinite(value) && value > 0);

  return [...new Set(parsed)].sort((a, b) => a - b);
};

/** Strict form check: EVERY non-empty token must be a positive integer ("10, dwa, 50" fails). */
export const areTiersInputTokensValid = (raw?: string | null): boolean => {
  const tokens = (raw ?? "").split(/[,;\s]+/).filter(Boolean);
  return tokens.length > 0 && tokens.every((token) => /^\d+$/.test(token) && Number(token) > 0);
};

/** Tiers of a config joined for the form input, e.g. "10, 50, 100". */
export const tiersToInput = (config: BadgeConfig): string => badgeConfigTiers(config).join(", ");

/** "Pierwszy trening 💪" → "pierwszy-trening" (key slug suggested from the name). */
export const slugifyBadgeKey = (name: string): string =>
  name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ł/g, "l")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
